var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},[_c('h1',[_vm._v("列表")]),_vm._v(" "),_vm._l((_vm.list),function(system,index){return _c('p',{key:system.id,staticClass:"123"},[_c('span',[_vm._v(_vm._s(system))]),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.deleteSystem(index)}}},[_vm._v("删除")])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21b76ab6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/subSystem/systemList.vue
// module id = null
// module chunks = 